exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".BrandLogo {\n  text-align: center; }\n  .BrandLogo img {\n    display: inline-block;\n    max-width: 100%;\n    margin: 0 auto; }\n  .BrandLogo[data-size=\"large\"] img {\n    max-width: 350px;\n    margin-top: 50px;\n    margin-bottom: 50px;\n    width: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/BrandLogo/BrandLogo.scss
// module id = 1564
// module chunks = 0